import { render, staticRenderFns } from "./ElementKeanggotaan.vue?vue&type=template&id=0d939701&"
import script from "./ElementKeanggotaan.vue?vue&type=script&lang=js&"
export * from "./ElementKeanggotaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports